import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ResultPageModel } from '../../Core/SortingAndPaging/Models/ResultPageModel';
import { DepositProduct } from '../../Models/Domains/Investment/DepositProduct';
import { DepositProductsQuery } from '../../Models/Domains/Investment/DepositProductsQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class DepositProductsSearchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: DepositProductsQuery, hierarchyId: string): Promise<ResultPageModel<DepositProduct>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/DepositProductsSearch/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query, hierarchyId: hierarchyId }

    return AjaxWrapper.post<ResultPageModel<DepositProduct>, any>(url, data);
  }
}

